import { useState, useEffect } from 'react';
import { useGetAttachmentsQuery, useQueryResultsQuery } from '../store/services/genieservice';
import { useSelector } from 'react-redux';
import { selectFirstAttachment, selectConversationId, selectMessageId } from '../store/features/genieSlice';

export const useGeniePolling = () => {
  const [pollingInterval, setPollingInterval] = useState<number | null>(null);
  const firstAttachment = useSelector(selectFirstAttachment);
  const conversation_id = useSelector(selectConversationId);
  const message_id = useSelector(selectMessageId);
 
  // Get attachments when conversation payload changes or after followUp
  const { data: attachments, 
    isLoading: isLoadingAttachments,
    error: attachmentsError } = useGetAttachmentsQuery(
    {
      conversation_id,
      message_id
    },
    {
      skip: !(message_id),
      pollingInterval: pollingInterval || 0
    }
  );

  // Query results for the first attachment
  useQueryResultsQuery({
    conversation_id,
    message_id,
    attachment_id: firstAttachment?.attachment_id,
    attachment: firstAttachment
  },
    {
      skip: !(message_id && firstAttachment?.attachment_id)
    }
  );

  // Poll for attachments until completed, failed, or error
  useEffect(() => {
    if (attachments && !isLoadingAttachments) {
      if (!['COMPLETED', 'FAILED'].includes(attachments?.status) && !attachmentsError) {
        // Start polling every 3 seconds
        setPollingInterval(3000);
      } else {
        // Stop polling when completed, failed, error, or conversation is closed
        setPollingInterval(null);
      }
    } else if (!attachments && (conversation_id || message_id) && !isLoadingAttachments) {
      // Start polling if we have a conversation but no attachments yet
      setPollingInterval(3000);
    }
  }, [attachments, attachmentsError, isLoadingAttachments, conversation_id, message_id]);

  return {
    attachments,
    isLoadingAttachments,
    attachmentsError,
    pollingInterval,
    setPollingInterval
  };
}; 